import { useLocation } from 'react-router-dom';
import {
  buildLocalizedPublicPath,
  getLocalizedLinkForCurrentPath,
  getLocalizedSwitchPath,
  isIndexablePublicPathname,
  normalizePublicPathname,
  stripLocaleFromPathname,
} from '@/config/publicSiteManifest.js';

export const resolvePublicLocale = (pathname: string) => stripLocaleFromPathname(pathname);

export const localizePathForCurrentPage = (pathname: string, targetBasePath: string) => {
  return getLocalizedLinkForCurrentPath(pathname, targetBasePath);
};

export const getLocaleSwitchPathWithSearch = (
  pathname: string,
  search: string,
  locale: string
) => {
  const nextPath = getLocalizedSwitchPath(pathname, locale);
  const params = new URLSearchParams(search);
  params.delete('lang');

  const nextSearch = params.toString();
  return nextSearch ? `${nextPath}?${nextSearch}` : nextPath;
};

export const resolveLocalizedPrivacyPath = (pathname: string) => {
  return isIndexablePublicPathname(pathname)
    ? localizePathForCurrentPage(pathname, '/privacy')
    : '/privacy';
};

export const resolveLocalizedTermsPath = (pathname: string) => {
  return isIndexablePublicPathname(pathname)
    ? localizePathForCurrentPage(pathname, '/terms')
    : '/terms';
};

export const usePublicLocale = () => {
  const location = useLocation();
  return resolvePublicLocale(location.pathname);
};

export const useLocalizedPublicPath = (targetBasePath: string) => {
  const location = useLocation();
  return localizePathForCurrentPage(location.pathname, targetBasePath);
};

export const normalizeCurrentPathname = (pathname: string) => normalizePublicPathname(pathname);

export const buildLocalizedPath = (basePath: string, locale: string) => {
  return buildLocalizedPublicPath(basePath, locale);
};
